import { h, render } from 'preact';

import Column from 'components/Column';
import Img from 'components/Img';
import PSmall from 'components/PSmall';

const JustikaIcon =
  'https://jtk-core-static.s3-ap-southeast-1.amazonaws.com/images/logo_justika_small.jpg';

const Footer = () => {
  return (
    <Column width="3" style={{ margin: "0 auto", display: "flex", alignItems: "center", justifyContent: "center"}}>
      <div style={{ display: "inline-block", width: "80px"}}>
        <PSmall>Powered by</PSmall>
      </div>
      <div style={{ display: "inline-block", width: "80px" }}>
        <Img alt="Justika Icon" src={JustikaIcon} style={{ width: "80px" }} />
      </div>
    </Column>
  )
}

export default Footer;